import { useQuery } from "@tanstack/react-query";
import { getPatientInfo } from "../services/apiServices";

export const usePatientInfoFromPhone = (phone) => {
    return useQuery({
        queryKey: ["patientInfo", phone],
        queryFn: () => getPatientInfo(phone),
        staleTime: 1000 * 60 * 5,
        cacheTime: 1000 * 60 * 10,
        enabled: !!phone,
    });
}